import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../shared/http-service.class';
import { MyLBApiConfiguration } from '../mylb-api.configuration';
import { IInstitutionDetail } from '../interfaces/iinstitution-details';

@Injectable({
	providedIn: 'root'
})
export class InstitutionService extends HttpService {
	constructor(config: MyLBApiConfiguration) {
		super(config, 'institution');
	}

	getAllInstitutions(): Observable<IInstitutionDetail[]> {
		return this.get<IInstitutionDetail[]>(`${this.serviceUrl}/all`);
	}

	getInstitutions(): Observable<IInstitutionDetail[]> {
		return this.get<IInstitutionDetail[]>(`${this.serviceUrl}/current-user`);
	}
}
